export default {
  // Header
  'nav.home': 'Baş sahypa',
  'nav.about': 'Biz barada',
  'nav.services': 'Hyzmatlar',
  'nav.products': 'Harytlar',
  'nav.contact': 'Habarlaşmak',
  'header.getQuote': 'Baha almak',
  
  // Hero
  'hero.title': 'Ýük awtoulaglary we tirkegleriniň ýokary hilli şaýlary',
  'hero.subtitle': 'Täjirçilik ulaglary üçin ýokary hilli şaýlary üpjün etmekde ygtybarly hyzmatdaşыňyz. Çalt eltip bermek, bäsdeşlik bahalary we hünärmen goldawy.',
  'hero.shopNow': 'Häzir satyn al',
  'hero.learnMore': 'Giňişleýin',
  
  // About
  'about.title': 'GB Group hakynda',
  'about.description': 'GB Group Türkmenistanda ýük awtoulaglary we tirkeginiň ýokary hilli ätiýаçлыk şaýларыны üpjün edýän öňdebaryjy kompaniýadyр. 15 ýyldan gowrak tejribe bilen, Merkezi Aziýadaky müşderilerimize ygtybarly awtoulag komponentlerini we ajaýyp hyzmaty hödürleýäris. Dünýä belli brendleriň resmi dilerleri hökmünde, her önümde hakykylygy we hili kepillendirýäris.',
  'about.experience': 'Ýyl tejribe',
  'about.products': 'Hilli önümler',
  'about.customers': 'Kanagatly müşderiler',
  'about.countries': 'Hyzmat edýän ýurtlar',
  'about.marketsServed': 'Hyzmat edýän bazarlar',
  'about.supportAvailable': 'Goldaw elýeterli',
  'about.ourStory': 'Biziň hekaýamyz',
  'about.storyP1': 'GB Group Truck\'s & Trailer\'s Spare Parts and Logistics 2004-nji ýylda ýönekeý missiýa bilen döredildi: Türkmenistanyň ösýän ulag pudagyna ygtybarly, ýokary hilli şaýlary üpjün etmek.',
  'about.storyP2': 'Soňky 20 ýylda biz kiçijik ýerli işden Türkmenistanyn 16 bazaryna hyzmat edýän öňdebaryjy üpjün edijä öwrüldik. Esasy amallaryňyz Aşgabat şäherinde ýerleşýär, bu ýerde esasy ammaryňyzy we logistika merkeziňizi saklaýarys.',
  'about.storyP3': 'Biz müşderilerimize awtoulag parklaryny netijeli işletmäge mümkinçilik berýän ygtybarly şaýlary üpjün etmekde ýöriteleşýäris. Hil we müşderi hyzmatyna bolan ygrarlylygymyz bizi sebitdäki ulag kompaniýalary üçin ileri tutulýan saýlawa öwürdi.',
  'about.contactUsToday': 'Şu gün biz bilen habarlaşyň',
  'about.ourJourney': 'Biziň ýolumyz',
  'about.journeySubtitle': 'Türkmenistanyň ulag pudagyna hyzmat etmäge bolan ösüş, innowasiýa we ygrarlylyk iki onýyllyk',
  'about.year2004': 'Kompaniýa esaslandyryldy',
  'about.year2004Desc': 'Türkmenistanda ýük awtoulaglary we tirkegleriniň şaýлары işinde ýolumuzy başлadyк',
  'about.year2008': 'Bazaryň giňelmegi',
  'about.year2008Desc': 'Türkmenistanyň birnäçe sebitine hyzmat etmek üçin amallary giňeltdik',
  'about.year2015': '16 bazara ýetildi',
  'about.year2015Desc': 'Türkmenistanyň 16 bazarynda üstünlikli gatnaşyk gurduk',
  'about.year2024': 'Öňdebaryjy üpjün ediji',
  'about.year2024Desc': 'Ygtybarly şaýlar we logistika çözгütlerinde ygtybarly leader bolduk',
  'about.ourMission': 'Biziň missiýamyz',
  'about.missionDesc': 'Türkmenistanyň ýük awtoulaglary we tirkegleriniň şaýларыны üpjün etmekde iň ygtybarly üpjün ediji bolmak, müşderilerimiziň awtoulag parklaryny rahat işletmäge mümkinçilik berýän ygtybarly önümleri we ajaýyp logistika hyzmatlaryny hödürlemek.',
  'about.qualityAssurance': 'Hil kepilligi',
  'about.qualityAssuranceDesc': 'Her şaý ygtybarlylyk we çydamlylyk üçin iň ýokary hil ülnülerine laýyk gelýär.',
  'about.fastLogistics': 'Çalt logistika',
  'about.fastLogisticsDesc': 'Türkmenistanyň 16 bazaryny öz içine alýan netijeli eltip bermek ulgamy.',
  'about.expertSupport': 'Hünärmen goldawy',
  'about.expertSupportDesc': 'Tehniki kömek we önüm maslahatyny berýän bilimli topar.',
  'about.ourLocations': 'Biziň ýerlerimiz',
  'about.locationsSubtitle': 'Aşgabatdaky esasy merkezi bilen Türkmenistanyň 16 bazaryna hyzmat edýäris',
  'about.mainHeadquarters': 'Esasy merkez - Aşgabat',
  'about.phone': 'Telefon',
  'about.marketsWeServe': 'Hyzmat edýän bazarlarymyz',
  'about.marketsDesc': 'Biz Türkmenistanyň 16 bazарына buýranç bilen hyzmat edýäris, her sebitdäki ulag kompaniýalaryna ygtybarly şaýlar we logistika çözгütlerini üpjün edýäris. Giň ulgamymyz nirede bolsaňyz, çalt eltip bermegi we ýerli goldawy üpjün edýär.',
  'partsStock': '500K+',
  
  // Services
  'services.title': 'Biziň hyzmatlarymyz',
  'services.subtitle': 'Ýük awtoulaglary we tirkegleriniň ähli zerurlyklaryna çözгütler',
  'services.wholesale': 'Lomaý söwda',
  'services.wholesaleDesc': 'Dilerler we ussahanalar üçin bäsdeşlik bahalary bilen lomaý sargytlar',
  'services.delivery': 'Çalt eltip bermek',
  'services.deliveryDesc': 'Siziň ýeriňize çalt we ygtybarly eltip bermek',
  'services.support': 'Tehniki goldaw',
  'services.supportDesc': 'Şaýlar saýlamakda we gurmakda 24/7 hünärmen kömegi',
  'services.warranty': 'Hil kepilligi',
  'services.warrantyDesc': 'Ähli önümler öndürijiniň kepilligi bilen üpjün edilýär',
  'services.truckParts': 'Ýük awtoulaglarynyň şaýlary',
  'services.truckPartsDesc': 'Mercedes-Benz, Volvo, Scania, MAN, DAF we Iveco ýaly ähli esasy ýük awtoulag markalary üçin asyl we alternatiw şaýlaryň giň toplumy.',
  'services.trailerParts': 'Tirkegiň şaýlary',
  'services.trailerPartsDesc': 'Öňdebaryjy öndürijilerden ýarym tirkeglerin, tekiz platformalaryň, tankerleriň we ýöriteleşdirilen tirkeglerin şaýlarynyň we esbaplarynyň doly sahypy.',
  'services.customOrders': 'Ýörite sargytlar',
  'services.customOrdersDesc': 'Tapylmaky gün sargytlar we awtoulag parklarynyň dolandyryşy we abatlaýyş ussahanalary üçin bäsdeşlik bahaýar bilen lomaý sargytlar üçin ýörite sargyt hyzmaty.',
  'services.whatWeOffer': 'Näme hödürleýäris',
  'services.whatWeOfferDesc': 'Ýük awtoulaglaryňyz we tirkegleriniz iň az durulga wagty bilen rahat işletmek üçin döredilen hyzmatlarynyň doly toplumy',
  'services.brandsWeSupport': 'Goldaýan markalarymyz',
  'services.brandsDesc': 'Biz ähli esasy ýük awtoulag we tirkeg markalary üçin ýokary hilli şaýlary we esabaplary üpjün edýäris. Mercedes-Benz, Volvo, Scania, MAN, DAF, Iveco we beýleki öňdebaryjy öndürijiler üçin giň seçim müm­kün.',
  
  // Brands
  'brands.badge': 'Resmi diler',
  'brands.title': 'Ygtybarly marka hyzmatdaşlary',
  'brands.subtitle': 'Biz dünýä belli markalaryň resmi dileri bolmak bilen buýsanýarys, size diňe asyl, ýokary hilli şaýlary üpjün edýäris.',
  'brands.guarantee': 'Ähli önümler öndürijiniň kepilligi we asyllyk kepilnamasy bilen gelýär',

  // Products
  'products.title': 'Öne Çykarylan Önümler',
  'products.viewAll': 'Ähli önümleri gör',
  'products.pageTitle': 'Biziň Önümlerimiz',
  'products.pageSubtitle': 'Ýük awtoulaglary we tirkegleriniň premium şaýlarynyň giň katalogyny göz aýlaň',
  'products.searchPlaceholder': 'Şaý gözle...',
  'products.allCategories': 'Ähli Kategoriýalar',
  'products.engineParts': 'Motor Şaýlary',
  'products.brakingSystem': 'Tormoz Ulgamy',
  'products.suspension': 'Asma',
  'products.lighting': 'Yşyklandyryş',
  'products.trailerParts': 'Tirkeg Şaýlary',
  'products.productsFound': 'önüm tapyldy',
  'products.outOfStock': 'Ammarda Ýok',
  'products.requestQuote': 'Teklip Soramak',
  'products.notifyMe': 'Habar Ber',
  'products.noResults': 'Önüm tapylmady',
  'products.noResultsDesc': 'Filtrleri ýa-da gözleg sözlerini üýtgetmäge synanyşyň',
  'products.loadMore': 'Has köp önüm görkez',
  'products.inStock': 'Ammarda Bar',
  'products.featured': 'Öne Çykarylan',
  'products.clearFilters': 'Ähli filtrleri arassala',

  // Products page extra
  'products.gbGroupCatalogue': 'GB Group Katalogy',
  'products.ownBrandBadge': 'GB Group Öz Markasy',
  'products.showcaseTitle1': 'Ýük Awtoulag Şaýlary',
  'products.showcaseTitle2': 'Disk Tormoz Tagtalary',
  'products.showcaseDesc': 'Ýewropa ýük awtoulaglary üçin ýörite döredilen ýokary öndürijilikli disk tormoz tagtalarynyň öz markamyz. Mercedes-Benz, Volvo, Scania, MAN, DAF we Iveco üçin OEM ülnülerine laýyk döredildi.',
  'products.badgeOEM': 'OEM Hili',
  'products.badgeEuroTrucks': 'Ýewropa Awtoulaglary',
  'products.badgeLongLasting': 'Uzak Çydamly',
  'products.badgeInStock': 'Ammarda Bar',
  'products.fullCatalogue': 'Doly Katalog',
  'products.browseAllParts': 'Ähli Şaýlara Göz At',
  'products.cantFind': 'Gözleýäniňizi Tapyp Bilmedimi?',
  'products.cantFindDesc': 'Toparymyz islendik ýük awtoulagy ýa-da tirkeg şaýyny tapyp bilýär. Biz bilen habarlaşyň, ony siziň üçin taparys.',
  'products.requestCustomQuote': 'Ýörite Teklip Soramak',
  'products.handpickedSelection': 'Saýlanan Harytlar',
  'products.featuredProducts': 'Öne Çykarylan Önümler',
  'products.featuredBadge': 'Öne Çykaryldy',
  'products.genuineTagline': 'Asyl Şaýlar, Ygtybarly Işleýiş',
  'products.cat.engine': 'Motor',
  'products.cat.braking': 'Tormoz',
  'products.cat.suspension': 'Asma',
  'products.cat.lighting': 'Yşyk',
  'products.cat.trailer': 'Tirkeg',
};